import { Component, Input } from '@angular/core';
import { ScreenInformationModel } from 'src/app/model/core/screen-information';
import { SecurityOptionProfileView } from 'src/app/model/security/option-profile';
import { SecurityUserLoginModel } from 'src/app/model/security/security-user.login';
import { BaseComponent } from '../../base/base.component';
import { KhuyanaHeaderService } from './khuyana-header.service';

@Component({
  selector: 'ms-khuyana-header',
  templateUrl: './khuyana-header.component.html',
  styleUrls: ['./khuyana-header.component.scss'],
})
export class KhuyanaHeaderComponent extends BaseComponent {
  @Input() showHeading = true;
  @Input() showMenu = true;
  screenInformation: ScreenInformationModel = {};
  userInformation: SecurityUserLoginModel = {};
  turnsQuantity = 0;
  options: SecurityOptionProfileView[] = [];
  displayMenu = false;

  constructor(override service: KhuyanaHeaderService) {
    super();
  }

  override onInit = () => {
    this.subscriptions.push(
      this.service
        .getScreenInformation()
        .subscribe((screen) =>
          setTimeout(() => (this.screenInformation = screen))
        ),
      this.service.getUserInformation().subscribe((userInfo) => {
        this.userInformation = userInfo;
        this.options = userInfo.options
          ? userInfo.options.map(this.setDefaultOptions)
          : [];
      }),
      this.service
        .getTurnsQuantity()
        .subscribe((quantity) => (this.turnsQuantity = quantity)),
      this.service.readUser().subscribe()
    );
  };

  setDefaultOptions = (
    option: SecurityOptionProfileView
  ): SecurityOptionProfileView => ({
    ...option,
    offsetTop: 0,
    isSelected: false,
    children:
      !option.children || option.children.length === 0
        ? []
        : option.children.map(this.setDefaultOptions),
  });

  onKeyEnter = ($ev: KeyboardEvent) => {
    const keyCode = $ev.code.toLowerCase();
    if (keyCode === 'enter' || keyCode === 'space') {
      this.displayMenu = true;
    }
  };
}
